document.addEventListener('DOMContentLoaded', () => {
	const countdownBlocks = document.querySelectorAll('.conecto-countdown');

	countdownBlocks.forEach((block) => {
		const end = block.getAttribute('data-countdown-end');
		
		if (!end) {
			return;
		}

		const targetTime = new Date(end).getTime();

		const daysEl = block.querySelector('[data-countdown-days]');
		const hoursEl = block.querySelector('[data-countdown-hours]');
		const minutesEl = block.querySelector('[data-countdown-minutes]');
		const secondsEl = block.querySelector('[data-countdown-seconds]');

		const updateCountdown = () => {
			const now = new Date().getTime();
			const distance = targetTime - now;

			if (distance <= 0) {
				if (daysEl) daysEl.textContent = '00';
				if (hoursEl) hoursEl.textContent = '00';
				if (minutesEl) minutesEl.textContent = '00';
				if (secondsEl) secondsEl.textContent = '00';
				return;
			}

			const d = Math.floor(distance / (1000 * 60 * 60 * 24));
			const h = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const m = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			const s = Math.floor((distance % (1000 * 60)) / 1000);

			if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
			if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
			if (minutesEl) minutesEl.textContent = String(m).padStart(2, '0');
			if (secondsEl) secondsEl.textContent = String(s).padStart(2, '0');
		};

		updateCountdown();
		setInterval(updateCountdown, 1000);
	});
});
